import { Play, Pause } from 'lucide-react';

import { Button } from '@app/shared/ui/atoms/Common';

interface PlayerControlsProps {
  isPlaying: boolean;
  togglePlay: () => void;
}

export const PlayerControls = ({ isPlaying, togglePlay }: PlayerControlsProps) => {
  return (
    <div className="relative flex justify-center items-center gap-6 text-2xl">
      {/*<Button*/}
      {/*  onMouseDown={() => startHold('back')}*/}
      {/*  onMouseUp={stopHold}*/}
      {/*  onMouseLeave={stopHold}*/}
      {/*  onClick={() => seek(Math.max(currentTime - 5, 0))}*/}
      {/*  className="p-2 h-fit"*/}
      {/*  variant="custom"*/}
      {/*>*/}
      {/*  <FastForward className="rotate-180 w-9 h-7" fill="currentColor" stroke="none" />*/}
      {/*</Button>*/}

      <Button onClick={togglePlay} className="h-fit" variant="custom">
        {isPlaying ? (
          <Pause className="size-[56px]" fill="currentColor" stroke="none" />
        ) : (
          <Play className="size-[56px]" fill="currentColor" stroke="none" />
        )}
      </Button>

      {/*<Button*/}
      {/*  onMouseDown={() => startHold('forward')}*/}
      {/*  onMouseUp={stopHold}*/}
      {/*  onMouseLeave={stopHold}*/}
      {/*  onClick={() => seek(Math.min(currentTime + 5, duration))}*/}
      {/*  className="p-2 h-fit"*/}
      {/*  variant="custom"*/}
      {/*>*/}
      {/*  <FastForward className="w-9 h-7" fill="currentColor" stroke="none" />*/}
      {/*</Button>*/}
    </div>
  );
};
